module.exports = __webpack_public_path__ + "static/media/room-8.73009591.jpeg";